import { StockCountTabContextType } from "../../../../utilities/stock-count";
import { StockCountTabContext } from "../../../../utilities/stock-count/context";

export type StockCountTabProviderProps = StockCountTabContextType & {
  children?: React.ReactNode;
};

export function StockCountTabProvider({
  children,
  selectedKey,
  index,
}: StockCountTabProviderProps) {
  return (
    <StockCountTabContext.Provider
      value={{
        index: index ?? 0,
        selectedKey,
      }}
    >
      {children}
    </StockCountTabContext.Provider>
  );
}
